import type { OnInit } from '@angular/core';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';

@Component({
  standalone: false,
  selector: 'invd-fm-header',
  templateUrl: './fm-header.component.html',
  styleUrls: ['./fm-header.component.scss'],
})
export class FmHeaderComponent implements OnInit {
  public isVisible = false;
  public isHeaderBanner = false;
  public messageBody = '';

  private router = inject(Router);
  private userService = inject(UserService);

  @Input() currentApp = 'Investor Direct';
  @Input() appLinks: {
    title: string;
    url: string;
  }[] = [
    {
      title: 'Dashboard',
      url: '',
    },
  ];

  @Input() helpTitle = 'Help';
  @Input() helpLinks: {
    title: string;
    url: string;
  }[] = [
    {
      title: 'Help Desk',
      url: '',
    },
    {
      title: 'FAQ',
      url: '',
    },
  ];

  @Input()
  userName: { firstName: string; lastName: string } = {
    firstName: 'Firstname',
    lastName: 'Lastname',
  };

  @Input()
  userLinks: any[] = [];

  @Output()
  bannerExitIconClick = new EventEmitter<any>();

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (
          (event.url.indexOf('enter-balances') > 0 || event.url.indexOf('enter-takedowns') > 0) &&
          event.url.indexOf('rcr-exchange') > 0 &&
          this.userService.isInternalUser
        ) {
          this.isHeaderBanner = true;
          this.messageBody = `You are currently making an exchange for ${this.userService.getTraderName()} at ${this.userService.getDealerName()}`;
        } else {
          this.isHeaderBanner = false;
          this.messageBody = '';
        }
      }
    });
  }

  toggleVisible(): void {
    this.isVisible = !this.isVisible;
  }

  public exitToRCRRequestPage(): void {
    this.bannerExitIconClick.emit({ showNavigationPopup: true });
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
